// Function for detecting Service Worker related FireFox security error.
// This is for users who have opted to clear out cookies and storage after closing FireFox.
// See bug: https://bugzilla.mozilla.org/show_bug.cgi?id=1429714 for details.
export function isFirefoxSecurityError(ex: any) {
    return ex instanceof Error && ex.message && ex.message.toLowerCase() === 'the operation is insecure.';
}
